import { runActions } from "../action";
import { IDecorator, INmis } from "../types";
import { Decorator } from "./decorator";
import filterTool from "../util/filterTool";
import Nmis from "../nmis";

export class FormDecorator extends Decorator implements IDecorator {
    public static NAME: string = "Form";

    // 

    /**
     * 获取当前对象实例
     * @returns 
     */
    getInstance() {
        return new FormDecorator();
    }

    /**
     * 1. 开始初始化
     */
    beforeInit() {
        this.addProp('model', this.nmis!.currentData);
    }

}